// Call Scripts tab — "My" vs "Company" call scripts for use during a live call,
// with lead variables filled in. The top-right button pops the scripts out into
// a small separate window to keep beside the dialer or on a second screen.

import React from 'react';
import { ExternalLink } from 'lucide-react';
import ScriptViewer from '../ScriptViewer.jsx';

export const POPOUT_FEATURES = 'width=520,height=720,menubar=no,toolbar=no,location=no,status=no,resizable=yes';

/** @param {string} [leadId] @returns {string} Pop-out URL for a lead's scripts. */
export const popoutUrl = (leadId) => `/scripts/popout${leadId ? `?leadId=${encodeURIComponent(leadId)}` : ''}`;

export default function CallScriptsTab({ lead }) {
  function popOut() {
    const win = window.open(popoutUrl(lead?._id), 'CallScripts', POPOUT_FEATURES);
    win?.focus?.();
  }

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex items-center justify-between gap-2 mb-2">
        <h3 className="text-sm font-semibold text-white/85">Call scripts</h3>
        <button
          type="button"
          onClick={popOut}
          title="Open in new window"
          aria-label="Open call scripts in new window"
          className="w-8 h-8 rounded-full bg-civix-purple hover:bg-civix-purpleDeep text-white flex items-center justify-center shadow-glow-purple"
        >
          <ExternalLink className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-1">
        <ScriptViewer lead={lead} />
      </div>
    </div>
  );
}
